import css from 'styled-jsx/css'

export const IssueStyle = css.global`
  button > span {
    pointer-events: none;
  }
`
